import { createSlice } from '@reduxjs/toolkit';
import { generateAiDescription } from './thunks/commonInfoThunks';

const aiDescriptionSlice = createSlice({
    name: 'aiDescription',
    initialState: {
        generatingFields: {},
        errors: {},
    },
    reducers: {
        clearAiDescriptionError: (state, action) => {
            const { fieldName } = action.payload || {};
            if (fieldName) delete state.errors[fieldName];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(generateAiDescription.pending, (state, action) => {
                const fieldName = action.meta.arg?.fieldName || 'comment';
                state.generatingFields[fieldName] = true;
                delete state.errors[fieldName];
            })
            .addCase(generateAiDescription.fulfilled, (state, action) => {
                const fieldName = action.meta.arg?.fieldName || 'comment';
                state.generatingFields[fieldName] = false;
            })
            .addCase(generateAiDescription.rejected, (state, action) => {
                const fieldName = action.meta.arg?.fieldName || 'comment';
                state.generatingFields[fieldName] = false;
                state.errors[fieldName] =
                    typeof action.payload === 'string'
                        ? action.payload
                        : 'aiDescriptionError';
            });
    },
});

export const { clearAiDescriptionError } = aiDescriptionSlice.actions;

export const aiDescription = aiDescriptionSlice.reducer;

export const selectIsGeneratingAiDescription = (state, fieldName) =>
    state.aiDescription?.generatingFields[fieldName] || false;

export const selectAiDescriptionError = (state, fieldName) =>
    state.aiDescription?.errors[fieldName];
